export const BASE_URL = (
  process.env.NODE_ENV === 'production'
    ? 'https://backend.thechart.ai'
    : 'http://localhost:3013'
)

